import _ from 'lodash';

type GraphQLError = {
  extensions: {
    response: {
      status: number;
    };
  };
};

type ErrorType = {
  graphQLErrors: GraphQLError[];
};

export const getStatusCodes = (error: ErrorType): number[] => {
  const statusCodes: number[] = _.get(error, 'graphQLErrors', []).map(
    (graphqlError: GraphQLError) => _.get(graphqlError, 'extensions.response.status'),
  );
  return statusCodes;
};
